import { ComparedValueEntity } from './media.entity'

export type SectionIdEntity =
  | 'home'
  | 'community'
  | 'chat'
  | 'songs'
  | 'videos'
  | 'events'
  | 'livestream'
  | 'shop'
  | 'other'

// 'all' | 'paid' | 'free' | a segment key (e.g. 'premium')
export type UserSegmentEntity = string

export type SegmentKindEntity = 'paid' | 'free'

export class SegmentInfoEntity {
  key!: string
  label!: string
  kind!: SegmentKindEntity
}

export class SectionPeriodEntity {
  date!: string
  visits!: number
  seconds!: number
  interactions!: number
}

export class SectionsTotalsEntity {
  visits!: ComparedValueEntity
  unique_visitors!: ComparedValueEntity
  seconds!: ComparedValueEntity
  interactions!: ComparedValueEntity
}

export class SectionMetricsEntity {
  section!: SectionIdEntity
  visits!: ComparedValueEntity
  unique_visitors!: ComparedValueEntity
  seconds!: ComparedValueEntity
  interactions!: ComparedValueEntity
  periods!: SectionPeriodEntity[]
}

export class SectionsSummaryEntity {
  segments!: SegmentInfoEntity[]
  totals!: SectionsTotalsEntity
  periods!: SectionPeriodEntity[]
  sections!: SectionMetricsEntity[]
}

export class SegmentTotalsEntity {
  seconds_per_user!: number
  visits_per_user!: number
  interactions_per_user!: number
}

export class SegmentComparisonItemEntity {
  section!: SectionIdEntity
  seconds_per_user!: number
  visits_per_user!: number
  interactions_per_user!: number
}

export class SegmentComparisonEntity {
  key!: string
  label!: string
  kind!: SegmentKindEntity
  web_users!: number
  totals!: SegmentTotalsEntity
  items!: SegmentComparisonItemEntity[]
}

export class SectionsComparisonEntity {
  segments!: SegmentComparisonEntity[]
}
